module.exports = __webpack_public_path__ + "img/pub-g-banner.6c382384.png";